(() => {
/**
 * Tab swap for block-video-colour. Main tab restores from server-rendered <template> + data-*
 * when present; a one-time WeakMap snapshot of first-paint main copy backs up empty templates.
 * @type {WeakMap<HTMLElement, { textClone: HTMLElement, imageBg: string, imageHref: string, playDataVideoUrl: string | null }>}
 */ const $3e94cf70d5e728dc$var$mainSnapshots = new WeakMap();
function $3e94cf70d5e728dc$var$isMainMiniTab(el) {
    if (el.classList.contains('video-mini--main')) return true;
    if (!el.hasAttribute('data-is-main')) return false;
    const v = el.getAttribute('data-is-main');
    return v === '1' || v === 'true' || v === '';
}
function $3e94cf70d5e728dc$var$safeText(v) {
    return v == null ? '' : String(v);
}
/** Stops href="undefined" resolving as a relative URL (e.g. /insights/undefined on insight pages). */ function $3e94cf70d5e728dc$var$sanitizeHref(u) {
    if (u == null) return '#';
    const s = String(u).trim();
    if (s === '' || s === 'undefined' || s === 'null') return '#';
    return s;
}
/** data-video-url: empty when missing; never the literal strings undefined/null. */ function $3e94cf70d5e728dc$var$sanitizeVideoUrlAttr(u) {
    if (u == null) return '';
    const s = String(u).trim();
    if (s === '' || s === 'undefined' || s === 'null') return '';
    return s;
}
function $3e94cf70d5e728dc$var$sanitizeCssBackgroundUrl(u) {
    if (u == null) return '';
    const s = String(u).trim();
    if (s === '' || s === 'undefined' || s === 'null') return '';
    return s;
}
function $3e94cf70d5e728dc$var$captureMainSlideSnapshot(videoBlock) {
    if ($3e94cf70d5e728dc$var$mainSnapshots.has(videoBlock)) return;
    const textEl = videoBlock.querySelector('.video-colour__main-text');
    const imageEl = videoBlock.querySelector('.video-colour__main-image');
    if (!textEl || !imageEl) return;
    const playBtn = imageEl.querySelector('.play-button');
    $3e94cf70d5e728dc$var$mainSnapshots.set(videoBlock, {
        textClone: textEl.cloneNode(true),
        imageBg: imageEl.style.backgroundImage || '',
        imageHref: $3e94cf70d5e728dc$var$sanitizeHref(imageEl.getAttribute('href')),
        playDataVideoUrl: playBtn ? playBtn.getAttribute('data-video-url') : null
    });
}
function $3e94cf70d5e728dc$var$activateMiniTab(videoBlock, el) {
    videoBlock.querySelectorAll('.video-mini').forEach((elem)=>{
        elem.classList.remove('active');
    });
    el.classList.add('active');
}
function $3e94cf70d5e728dc$var$applyMainSlide(videoBlock) {
    const textEl = videoBlock.querySelector('.video-colour__main-text');
    const tpl = videoBlock.querySelector('template.video-colour__main-text-template');
    if (textEl && tpl && tpl.content) {
        const frag = tpl.content.cloneNode(true);
        while(textEl.firstChild)textEl.removeChild(textEl.firstChild);
        while(frag.firstChild)textEl.appendChild(frag.firstChild);
        // If <template> was emptied by an optimizer or clone failed, restore first-paint copy.
        const hasMainCopy = textEl.querySelector('.title, .copy, a.button, p.pre-title');
        if (!hasMainCopy) {
            const snap = $3e94cf70d5e728dc$var$mainSnapshots.get(videoBlock);
            if (snap?.textClone) {
                while(textEl.firstChild)textEl.removeChild(textEl.firstChild);
                const backup = snap.textClone.cloneNode(true);
                while(backup.firstChild)textEl.appendChild(backup.firstChild);
            }
        }
    } else {
        const snap = $3e94cf70d5e728dc$var$mainSnapshots.get(videoBlock);
        if (!snap || !snap.textClone) return;
        const textNode = videoBlock.querySelector('.video-colour__main-text');
        const imageElLegacy = videoBlock.querySelector('.video-colour__main-image');
        if (textNode && textNode.parentNode) textNode.parentNode.replaceChild(snap.textClone.cloneNode(true), textNode);
        if (imageElLegacy) {
            imageElLegacy.style.backgroundImage = snap.imageBg;
            imageElLegacy.setAttribute('href', $3e94cf70d5e728dc$var$sanitizeHref(snap.imageHref));
            const pb = imageElLegacy.querySelector('.play-button');
            if (pb && snap.playDataVideoUrl != null) pb.setAttribute('data-video-url', $3e94cf70d5e728dc$var$sanitizeVideoUrlAttr(snap.playDataVideoUrl));
        }
        return;
    }
    const imageEl = videoBlock.querySelector('.video-colour__main-image');
    const mainBg = videoBlock.getAttribute('data-main-bg');
    const mainHref = videoBlock.getAttribute('data-main-href') || '';
    if (imageEl) {
        const bg = $3e94cf70d5e728dc$var$sanitizeCssBackgroundUrl(mainBg);
        imageEl.style.backgroundImage = bg ? `url(${bg})` : '';
        imageEl.setAttribute('href', $3e94cf70d5e728dc$var$sanitizeHref(mainHref));
        const pb = imageEl.querySelector('.play-button');
        if (pb) pb.setAttribute('data-video-url', $3e94cf70d5e728dc$var$sanitizeVideoUrlAttr(mainHref));
    }
}
function $3e94cf70d5e728dc$var$applyAdditionalSlide(videoBlock, el) {
    if ($3e94cf70d5e728dc$var$isMainMiniTab(el)) {
        $3e94cf70d5e728dc$var$applyMainSlide(videoBlock);
        return;
    }
    $3e94cf70d5e728dc$var$captureMainSlideSnapshot(videoBlock);
    const title = el.getAttribute('data-title') ?? '';
    const intro = el.getAttribute('data-intro') ?? '';
    const image = el.getAttribute('data-image') ?? '';
    const video = el.getAttribute('data-video') ?? '';
    const choice = el.getAttribute('data-choice') ?? 'Watch the Video';
    const imageBlock = videoBlock.querySelector('.video-colour__main-image');
    const videoLinks = videoBlock.querySelectorAll('.video-colour__main .link');
    const videoTitle = videoBlock.querySelector('.title');
    const videoIntro = videoBlock.querySelector('.copy');
    const videoChoice = videoBlock.querySelector('.pre-title');
    const videoButton = videoBlock.querySelector('.button');
    const href = $3e94cf70d5e728dc$var$sanitizeHref(video);
    const bgUrl = $3e94cf70d5e728dc$var$sanitizeCssBackgroundUrl(image);
    if (imageBlock) {
        imageBlock.style.backgroundImage = bgUrl ? `url(${bgUrl})` : '';
        imageBlock.setAttribute('href', href);
        const pb = imageBlock.querySelector('.play-button');
        if (pb) pb.setAttribute('data-video-url', $3e94cf70d5e728dc$var$sanitizeVideoUrlAttr(video));
    }
    videoLinks.forEach((linkEl)=>{
        linkEl.setAttribute('href', href);
    });
    if (videoTitle) videoTitle.textContent = $3e94cf70d5e728dc$var$safeText(title);
    if (videoIntro) videoIntro.textContent = $3e94cf70d5e728dc$var$safeText(intro);
    if (videoChoice) videoChoice.textContent = $3e94cf70d5e728dc$var$safeText(choice);
    if (videoButton) videoButton.textContent = $3e94cf70d5e728dc$var$safeText(choice);
}
function $3e94cf70d5e728dc$var$initVideoColourBlocks() {
    document.querySelectorAll('.block-video-colour').forEach((videoBlock)=>{
        if (!videoBlock.querySelector('.video-colour__other_videos')) return;
        $3e94cf70d5e728dc$var$captureMainSlideSnapshot(videoBlock);
    });
    document.querySelectorAll('.block-video-colour .video-mini').forEach((el)=>{
        const run = (e)=>{
            e.preventDefault();
            const videoBlock = el.closest('.block-video-colour');
            if (!videoBlock) return;
            $3e94cf70d5e728dc$var$activateMiniTab(videoBlock, el);
            if ($3e94cf70d5e728dc$var$isMainMiniTab(el)) $3e94cf70d5e728dc$var$applyMainSlide(videoBlock);
            else $3e94cf70d5e728dc$var$applyAdditionalSlide(videoBlock, el);
            videoBlock.scrollIntoView({
                behavior: 'smooth'
            });
        };
        el.addEventListener('click', run);
        el.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                run(e);
            }
        });
    });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $3e94cf70d5e728dc$var$initVideoColourBlocks);
else $3e94cf70d5e728dc$var$initVideoColourBlocks();

})();
//# sourceMappingURL=video-colour.js.map
